import { useHint } from "./use-hint";
import { HintView } from "./view-hint";
import type { HintProps } from "./types-hint";

export function Hint(props: HintProps) {
  const vm = useHint();

  return <HintView {...props} {...vm} />;
}

export type * from "./types-hint";
